import { getBaseMetaTitle } from '@/environments'

const CategoryDetail = () => import('./Main')

const route = {
  path: '/awards/:id',
  name: 'category-detail',
  component: CategoryDetail,
  meta: {
    title: `Awards - ${getBaseMetaTitle}`
  }
}

export default route
